// Referenssihaku ajax
var referenceContainer = jQuery('#reference-container');
var referenceList = null;
if(referenceContainer){
  referenceContainer.append('<img id="loading-reference" src="/wp-content/themes/brang/assets/images/loading.gif" alt="Ladataan..." title="Ladataan...">')
  var jqxhr = jQuery.get( "/wp-json/wp/v2/referenssit?_embed", function( data ) {
  })
  .done(function( data ) {
    referenceList = data;
    var slickReferenceContainer = jQuery('#slick-slide-reference-container');
    jQuery.each(referenceList, function(idx, obj){
      // jQuery.each( obj.acf.kategoria, function( i, val ) {
      //   category_string = category_string.concat(val, ' ');
      // });
      var articleImage = obj._embedded['wp:featuredmedia']['0'].source_url
      slickReferenceContainer.append('<div style="background-image:url('+ articleImage +');" class="slick-slide-reference"><div class="reference-inner"><h2 class="custom-heading">'+ obj.title.rendered +'</h2>'+ obj.excerpt.rendered +' <div class="custom-button-container"> <a class="custom-button" href="'+ obj.link +'">Lue lisää</a> </div></div></div>');
      setTimeout(function() {
        jQuery('#slick-slide-reference-container').slick({
          dots: true,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 5000,
          slidesToShow: 2,
          slidesToScroll: 1,
          responsive: [
    {
      breakpoint: 762,
      settings: {
        slidesToShow: 1,
      }
    },


  ]
        });
      });
      jQuery('#loading-reference').hide();
    });

  })
  .fail(function() {
    console.log('error');
  })
  .always(function() {
  });
}


var referenceMasonryContainer = jQuery('.referenssit-grid');
var referenceMasonryList = null;
if(referenceMasonryContainer){
  referenceMasonryContainer.append('<img id="loading-reference" src="/wp-content/themes/brang/assets/images/loading.gif" alt="Ladataan..." title="Ladataan...">')
  var jqxhr = jQuery.get( "/wp-json/wp/v2/referenssit?_embed", function( data ) {
  })
  .done(function( data ) {
    referenceMasonryList = data;
    var referenceMasonryContainer = jQuery('.referenssit-grid');

    var $grid = jQuery('.referenssit-grid').masonry({
      columnWidth: '.grid-item',
      itemSelector: '.grid-item',
      percentPosition: true,
      gutter: 20,
    });

    jQuery.each(referenceMasonryList, function(idx, obj){
      // jQuery.each( obj.acf.kategoria, function( i, val ) {
      //   category_string = category_string.concat(val, ' ');
      var articleImage;
      // });
      try {
         articleImage = obj._embedded['wp:featuredmedia']['0'].source_url
      }
      catch(err) {
        articleImage = '/wp-content/themes/brang/assets/images/brang-placeholder.png'
      }
      var $item = jQuery('<div class="grid-item"><img src="'+articleImage+'"><div class="grid-item-inner"><h2>'+obj.title.rendered+'</h2>'+obj.excerpt.rendered+'<div class="custom-button-container"><a href="'+obj.link+'">Lue lisää</a></div></div</div>')
      $grid.append($item).masonry( 'appended', $item );
      $grid.imagesLoaded().progress( function() {
        $grid.masonry('layout');
      });

      jQuery('#loading-reference').hide();

    });

  })
  .fail(function() {
    console.log('error');
  })
  .always(function() {
  });
}
